import { Row, Col, Card, Button, Skeleton, Carousel, Image } from "antd";
import React, { useState, useEffect } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import { ArrowLeftOutlined, LeftOutlined, RightOutlined } from "@ant-design/icons";
import apiPath from "../../constants/apiPath";
import { Badge } from "antd";

import lang from "../../helper/lang";

function View() {
  const params = useParams();
  const { request } = useRequest();
  const [list, setList] = useState({});
  const [orderList, setOrderList] = useState({});
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();


  const fetchData = (id) => {
    setLoading(true);
    request({
      url: apiPath.viewReport + "/" + id,
      method: "GET",
      onSuccess: (data) => {
        setLoading(false);
        setList(data.data);
      },
      onError: (error) => {
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const handleChangeStatus = (id, status) => {
    setLoading(true);
    request({
      url: apiPath.statusChangeReport + id,
      method: "POST",
      data: {
        status: status,
      },
      onSuccess: (data) => {
        setLoading(false);
        const successMessage =
          status === "accepted"
            ? "Post accepted successfully!"
            : "Post rejected successfully!";

        ShowToast(successMessage, Severty.SUCCESS);
        // ShowToast(data.data.message, Severty.SUCCESS);
        fetchData(id);
      },
      onError: (error) => {
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  useEffect(() => {
    fetchData(params.id);
  }, []);

  return (
    <>
      <Row gutter={[24, 0]}>
        <Col span={24}>
          <div className="view-inner-cls float-right upper-back-button">
            <Link className="ant-btn ant-btn-primary" to="/report/">
              <ArrowLeftOutlined />
            </Link>
          </div>

        </Col>
        <Col span={12} xs={24} md={24}>
          <Card title={`${lang("Report")} ${lang("Detail")}`}>
            {loading ? (
              [1, 2].map((item) => <Skeleton active key={item} />)
            ) : (
              <Row gutter={[24, 24]}>
                <Col span={24} md={6}>
                  <div className="scroll-bar">
                  {list.reportForUser && (
                    <Image src={list.reportForUser.image} height={250} width={250}/>
                  )}

                    {list.postDetails?.files?.length > 0 && (
                      <Carousel
                        autoplay
                        dots
                        arrows
                        prevArrow={
                          <LeftOutlined
                            style={{ fontSize: "24px", color: "#fff" }}
                          />
                        }
                        nextArrow={
                          <RightOutlined
                            style={{ fontSize: "24px", color: "#fff" }}
                          />
                        }
                      >
                        {list.postDetails?.files?.map((file, index) => {
                          const isVideo = file.url.match(/\.(mp4|webm|ogg)$/i);
                          return (
                            <div key={index} className="item">
                              {isVideo ? (
                                <video controls autoPlay style={{ width: "100%" }}>
                                  <source src={file.url} type="video/mp4" />
                                </video>
                              ) : (
                                <img src={file.url} alt="img" />
                              )}
                            </div>
                          );
                        })}
                      </Carousel>
                    )}
                  </div>
                </Col>
                <Col span={24} md={18}>
                  <div className="view-main-list">

                    {list.reportForUser &&  <>
                      <div className="view-inner-cls">
                      <h5>Reported User:</h5>
                        <h6>
                          {list?.reportForUser?.name
                            ? list?.reportForUser?.name
                            : "-"}
                        </h6>
                        </div>
                      <div className="view-inner-cls">
                      <h5>Reported User Name:</h5>
                        <h6>
                          {list?.reportForUser?.username
                            ? list?.reportForUser?.username
                            : "-"}
                        </h6>
                      </div> 
                      <div className="view-inner-cls">
                      <h5>Reported Message:</h5>
                        <h6>
                          {list?.reportForUser?.message
                            ? list?.reportForUser?.message
                            : "-"}
                        </h6>
                        </div></>
                    }
                    {list.postDetails && (
                      <div className="view-inner-cls">
                      <h5>Post caption:</h5>
                        <h6>
                          {list?.postDetails?.caption
                            ? list?.postDetails?.caption
                            : "-"}
                        </h6>
                      </div> )
                    }
                    <div className="view-inner-cls">
                      <h5>Username :</h5>
                      <h6><a className="cap avatar-text" onClick={() => navigate(`/user/customer/view/${list?.userDetails?._id}`)}>{list?.userDetails?.name}</a></h6>
                    </div>
                    <div className="view-inner-cls">
                      <h5>Email :</h5>
                      <h6>{list?.userDetails?.email}</h6>
                    </div>
                    <div className="view-inner-cls">
                      <h5>Report message :</h5>
                      <h6>{list?.message}</h6>
                    </div>
                    <div className="view-inner-cls">
                      <h5>Report Status :</h5>
                      <h6>{list?.status}</h6>
                    </div>
                    {list.status === "pending" && (

                      <div className="view-inner-cls">

                        <h5>Report Option :</h5>
                        <h6><div className="main-new-class-acceptjj">
                          <Button
                            onClick={() =>
                              handleChangeStatus(params.id, "accepted")
                            }
                          >
                            Accept
                          </Button>
                          <Button
                            onClick={() =>
                              handleChangeStatus(params.id, "rejected")
                            }
                          >
                            Reject
                          </Button>
                        </div></h6>

                      </div>

                    )}

                  </div>
                </Col>
                {/* {list.status === "pending" && (
                  <Col span={24}>
                    <div className="main-new-class-acceptjj">
                      <Button
                        onClick={() =>
                          handleChangeStatus(params.id, "accepted")
                        }
                      >
                        Accept
                      </Button>
                      <Button
                        onClick={() =>
                          handleChangeStatus(params.id, "rejected")
                        }
                      >
                        Reject
                      </Button>
                    </div>
                  </Col>
                )} */}
              </Row>
            )}
          </Card>
        </Col>
      </Row>


      {/* <Card title="Order Detail" className="mt-3">
        <Row gutter={16}>
          <Col span={12} xs={24} md={24}>
            {loading ? [1,2,3].map(item => <Skeleton active key={item} />) :
              <div className="view-main-list">
                <Table
                  loading={loading}
                  columns={orderColumns}
                  dataSource={orderList}
                  className="ant-border-space"
                />
              </div>
            }
          </Col>
        </Row>
      </Card> */}
    </>
  );
}

export default View;
